var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/bell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.4999 14.1667H16.6666L15.4958 12.9959C15.1783 12.6784 14.9999 12.2477 14.9999 11.7987V9.16667C14.9999 6.98964 13.6086 5.13757 11.6666 4.45118V4.16667C11.6666 3.24619 10.9204 2.5 9.99992 2.5C9.07944 2.5 8.33325 3.24619 8.33325 4.16667V4.45118C6.39126 5.13757 4.99992 6.98964 4.99992 9.16667V11.7987C4.99992 12.2477 4.82154 12.6784 4.50403 12.9959L3.33325 14.1667H7.49992M12.4999 14.1667V15C12.4999 16.3807 11.3806 17.5 9.99992 17.5C8.61921 17.5 7.49992 16.3807 7.49992 15V14.1667M12.4999 14.1667H7.49992",
    stroke: "#FF509A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7e5d491fa3b009f4d08430fdaebf1503.svg";
export { ForwardRef as ReactComponent };